export class SearchBox {

  constructor () {
    $('[data-action="open-search-box"]').on('click', $.proxy(this.openSearchBox, this));
  }

  openSearchBox() {
    $('[data-role="search-box"]').addClass('open');
    $('input[name=q_widget]').focus()
  }
}



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Theme/SearchBox.js